import React from "react";
import FeedbackLogComponent from "./feedbackLog.component";

const FeedbackLogContainer = () => {
  return (
    <div>
      <FeedbackLogComponent />
    </div>
  );
};

export default FeedbackLogContainer;
